#!/usr/bin/env node
import LINECommand from '../commands/line-command';

LINECommand.cli();
